import { useEffect, useState } from 'react'
import { FileSpreadsheet } from 'lucide-react'
import Button from '../../components/Button'
import ExcelUploadFields from '../../components/ExcelUploadFields'
import { FormBody } from '../../components/Form'
import Modal from '../../components/Modal'
import { strings as S } from './strings'
import './modals.css'

const ACCEPT = '.csv,.xls,.xlsx'
const EXTENSIONS = ['csv', 'xls', 'xlsx']

/**
 * `#add_modal` in excel mode — `showCreationForm(true, type)`.
 *
 * All four live file types share one body; only the title, the hint, the column
 * table and the template link change (js.cshtml:489-538). The fifth type in the
 * legacy switch (`Users`) is unreachable because its menu item is commented out.
 */
export default function UserImportModal({ open, type, onClose, onSubmit }) {
  const [file, setFile] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!open) return
    setFile(null)
    setError('')
  }, [open, type])

  const config = S.importTypes[type]
  if (!config) return null

  const submit = (event) => {
    event.preventDefault()
    const extension = file?.name.split('.').pop()?.toLowerCase()
    if (!file || !EXTENSIONS.includes(extension)) {
      setError(S.importModal.fileError)
      return
    }
    onSubmit({ fileType: type, file })
  }

  return (
    <Modal
      open={open}
      title={config.title}
      icon={FileSpreadsheet}
      hint={config.hint}
      onClose={onClose}
      footer={
        <Button type="submit" form="import-users-form">
          {S.importModal.save}
        </Button>
      }
    >
      <form id="import-users-form" onSubmit={submit} noValidate>
        <FormBody>
          <ExcelUploadFields
            id="import-users-file"
            name="csv"
            accept={ACCEPT}
            columns={config.columns}
            templateHref={`/root/ExcelTemplates/Users_${type}.xlsx`}
            error={error}
            strings={S.importModal}
            onChange={(selected) => {
              setFile(selected)
              setError('')
            }}
          />
        </FormBody>
      </form>
    </Modal>
  )
}
